module.exports = __webpack_public_path__ + "static/media/md-easel.9f884ca9.svg";